"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { ComicNeue } from "@/lib/fonts";
export const PageStyles = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp2, t0);
  return null;
};
function _temp() {
  const existingStyle = document.getElementById("previously-page-styles");
  if (existingStyle) {
    existingStyle.remove();
  }
}
function _temp2() {
  const styleElement = document.createElement("style");
  styleElement.id = "previously-page-styles";
  styleElement.textContent = `
      body {
        cursor: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAZklEQVR4AWIAgn/uBT6A9uoAAwAQiIJo97/0Rgy0ANoJH8MPeEgtqwPQEACqCoQHAKECQKgAECoAhAoAoQJAqAAQxh1oPQfcW3kJpxHtL1AAHAwEwwdYiH8BIEgBTBRAAAEEEEAAG7mRt30hEhoLAAAAAElFTkSuQmCC") 2 1, auto;
      }
      a, button {
        cursor: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgAgMAAAAOFJJnAAAACVBMVEVHcEwAAAD///8W1S+BAAAAAXRSTlMAQObYZgAAAEdJREFUeAFjoAVghTGkHIhghMAYmQEwxlIYYxlYlSiQMQEsELUKyli1ahWYwQZjMGIwGLKQGA4QA1EYEP0rGVAZrKGhSF4BAHw/HsVwshytAAAAAElFTkSuQmCC") 16 12, auto;
      }
      main {
        font-family: ${ComicNeue.style.fontFamily}, var(--font-sans);
        font-weight: 700;
        font-size: 1em;
        text-align: center;
      }
      main iframe + p em,
      main img + em {
        display: block;
        text-align: center;
        font-style: normal;
        font-size: 0.95em;
        font-weight: 700;
      }
    `;
  document.head.appendChild(styleElement);
  return _temp;
}